<template>
    <div>
        <div id="spatial-reference-columns">
            <fieldset class="slds-form-element slds-form_compound">
                <div class="slds-form-element__control">
                    <div class="slds-form-element__group">
                        <div class="slds-form-element__row slds-wrap">
                            <div
                                v-for="(column, i) in Object.keys(spatialReference)"
                                :key="i"
                                class="cols slds-form-element slds-size_1-of-3"
                            >
                                <label
                                    class="slds-form-element__label"
                                    for="text-input-id-1"
                                >
                                    {{ spatialReference[column].label }}
                                </label>
                                <div class="slds-form-element__control slds-m-bottom_small">
                                    <b>{{ spatialReference[column].value || '- Not Provided -' }}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
    name: 'SpatialReference',
    computed: {
        ...mapState({
            store__datasetReadOnly: 'datasetReadOnly'
        }),
        spatialReference() {
            const allSpatialReferences = {
                latitude: {
                    label: 'Latitude',
                    value: null
                },
                longitude: {
                    label: 'Longitude',
                    value: null
                },
                street: {
                    label: 'Street',
                    value: null
                },
                city: {
                    label: 'City',
                    value: null
                },
                state: {
                    label: 'State',
                    value: null
                },
                country: {
                    label: 'Country',
                    value: null
                },
                zip: {
                    label: 'Zip Code',
                    value: null
                }
            };

            this.store__datasetReadOnly.columnFormat.forEach((column) => {
                if (column.spatial === 'latitude') {
                    allSpatialReferences.latitude.value = column.label;
                }
                if (column.spatial === 'longitude') {
                    allSpatialReferences.longitude.value = column.label;
                }
                if (column.spatial === 'street') {
                    allSpatialReferences.street.value = column.label;
                }
                if (column.spatial === 'city') {
                    allSpatialReferences.city.value = column.label;
                }
                if (column.spatial === 'state') {
                    allSpatialReferences.state.value = column.label;
                }
                if (column.spatial === 'country') {
                    allSpatialReferences.country.value = column.label;
                }
                if (column.spatial === 'zip') {
                    allSpatialReferences.zip.value = column.label;
                }
            });

            return allSpatialReferences;
        }
    }
};
</script>

<style lang="scss" scoped>
    /deep/ .slds-popover_tooltip {
        display: none;
        position: absolute;
        visibility: visible;
        opacity: 1;
        overflow: visible;
        cursor: default;
        z-index: 9999;

        .slds-popover__body {
            white-space: normal;
            padding: .75rem;
        }
    }

    #spatial-reference-columns .cols:first-child {
        padding-left: .5rem;
    }
</style>
